/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".common-expressions-modal .modal-dialog{width:37.5rem}.common-expressions-modal .modal-content{border-radius:1rem;overflow:hidden;border:none;width:37.5rem}.common-expressions-modal-iframe{width:37.5rem;display:block}"];
export { styles as styles };
//# sourceMappingURL=common-expressions-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/common-expressions-modal/common-expressions-modal.component.scss.ngstyle.js
// module id = 1358
// module chunks = 27 28 29